export default __webpack_public_path__ + "static/media/69-Grandbaldesvins-cœurs.3cdaf709.jpg";